import { useState } from "react";
import axios from "axios";
import html2pdf from "html2pdf.js";
import "./NumReport.scss";

/* IMPORT PROFILE OBJECTS */
import { destinyProfiles as balanceProfiles } from "../Balance/Balance";
import { destinyProfiles as destinyProfiles } from "../Destiny/Destiny";
import { pathProfiles } from "../LifePath/Path";
import { destinyProfiles as birthProfiles } from "../Birth/Birth";
import { destinyProfiles as soulProfiles } from "../Soul/Soul";
import { destinyProfiles as nameProfiles } from "../Name/Name";
import { unluckyProfiles } from "../UnluckyNumbers/Unlucky";
import { chineseProfiles } from "../Chinese/Chinese";
import { luckyNumberProfiles } from "../LuckyNumber/LuckyNumber";
import { destinyProfiles as kuaProfiles } from "../Kua/Kua";
import { unluckyProfiles as personalYearProfiles } from "../PersonalYear/Personal";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Footer from "../../../components/Footer/Footer";
import Zodiac from "../../../components/ZodiacSign/Zodiac";


const NumerologyMasterReport = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    day: "1",
    month: "January",
    year: "2000",
    gender: "male",
  });

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleTryAgain = () => setReport(null);

  const generateReport = async (e) => {
    e.preventDefault();
    const birthMonth = new Date(`${form.month} 1, 2000`).getMonth() + 1;

    try {
      setLoading(true);
      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
          `?firstName=${form.firstName}` +
          `&lastName=${form.lastName}` +
          `&birthYear=${form.year}` +
          `&birthMonth=${birthMonth}` +
          `&birthDay=${form.day}` +
          `&gender=${form.gender}`
      );

      const n = res.data.data.numerology;

      setReport({
        losu: n.loShuGrid,

        lifePath: { number: n.lifePathNumber, profile: pathProfiles[n.lifePathNumber] },
        destiny: { number: n.destinyNumber, profile: destinyProfiles[n.destinyNumber] },
        personalYear: { number: n.personalYear, profile: personalYearProfiles[n.personalYear] },

        birth: { number: n.birthNumber, profile: birthProfiles[n.birthNumber] },
        soul: { number: n.soulUrgeNumber, profile: soulProfiles[n.soulUrgeNumber] },
        name: { number: n.nameNumber, profile: nameProfiles[n.nameNumber] },
        balance: { number: n.balanceNumber, profile: balanceProfiles[n.balanceNumber] },

        lucky: { number: n.luckyNumber, profile: luckyNumberProfiles[n.luckyNumber] },
        unlucky: { number: n.unluckyNumber, profile: unluckyProfiles[n.unluckyNumber] },
        chinese: { number: n.chineseLuckyNumber, profile: chineseProfiles[n.chineseLuckyNumber] },
        kua: { number: n.kuaNumber, profile: kuaProfiles[n.kuaNumber] },
      });
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = () => {
    html2pdf().from(document.getElementById("numerology-pdf")).set({
      margin: 8,
      filename: "Numerology_Report.pdf",
      html2canvas: { scale: 2 },
      jsPDF: { format: "a4", orientation: "portrait" },
    }).save();
  };

  return (
    <div className="numerology-wrapper">
      <InnerNav />
      <Zodiac />
      <div className="numerology-card">

        {!report && (
          <form className="numerology-form" onSubmit={generateReport}>
            <h1>Numerology Master Report</h1>
            <p className="subtitle">Discover the vibrational blueprint of your life</p>

            <input name="firstName" placeholder="First Name" onChange={handleChange} required />
            <input name="lastName" placeholder="Last Name" onChange={handleChange} required />

            <div className="dob">
              <select name="day" onChange={handleChange}>
                {[...Array(31)].map((_, i) => <option key={i + 1}>{i + 1}</option>)}
              </select>
              <select name="month" onChange={handleChange}>
                {["January","February","March","April","May","June","July","August","September","October","November","December"]
                  .map(m => <option key={m}>{m}</option>)}
              </select>
              <select name="year" onChange={handleChange}>
                {Array.from({ length: 100 }).map((_, i) => {
                  const y = 2026 - i;
                  return <option key={y}>{y}</option>;
                })}
              </select>
            </div>

            <select name="gender" onChange={handleChange}>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>

            <button type="submit" disabled={loading}>
              {loading ? "Calculating..." : "Generate Report"}
            </button>
          </form>
        )}

        {report && (
          <>
            <div id="numerology-pdf" className="numerology-pdf">

              <div className="pdf-header">
                <h1>Numerology Master Report</h1>
                <p>
                  <strong>{form.firstName} {form.lastName}</strong><br />
                  {form.day} {form.month} {form.year}
                </p>
              </div>

              <LoShuGrid data={report.losu} />

              <DetailedSection title="Personality (Life Path)" data={report.lifePath} />
              <DetailedSection title="Destiny Number" data={report.destiny} />

              {Object.entries(report).map(
                ([key, value]) =>
                  !["losu","lifePath","destiny"].includes(key) && (
                    <DetailedSection key={key} title={key} data={value} />
                  )
              )}

              <Conclusion report={report} name={form.firstName} />
            </div>

            <div className="actions">
              <button onClick={downloadPDF}>Download PDF</button>
              <button className="secondary" onClick={handleTryAgain}>Try Again</button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

/* ================= DETAILED SECTION ================= */
const DetailedSection = ({ title, data }) => {
  const p = data.profile || {};

  return (
    <div className="section">
      <div className="section-header">
        <div className="number-badge">{data.number}</div>
        <h2>{title.replace(/([A-Z])/g, " $1")}</h2>
      </div>

      {p.title && <h3>{p.title}</h3>}

      {p.keywords && (
        <p className="keywords">
          <strong>Key Themes:</strong> {p.keywords}
        </p>
      )}

      {p.overview && (
        <p className="overview">
          <strong>Overview:</strong> {p.overview}
        </p>
      )}

      {Array.isArray(p.strengths) && p.strengths.length > 0 && (
        <>
          <h4>Strengths</h4>
          <ul>
            {p.strengths.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </>
      )}

      {Array.isArray(p.challenges) && p.challenges.length > 0 && (
        <>
          <h4>Challenges</h4>
          <ul>
            {p.challenges.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </>
      )}

      {p.guidance && (
        <>
          <h4>Guidance</h4>
          <p>{p.guidance}</p>
        </>
      )}
    </div>
  );
};

/* ================= CONCLUSION ================= */
const Conclusion = ({ report, name }) => {
  const { lifePath, destiny, personalYear } = report;

  return (
    <div className="section conclusion">
      <h2>Conclusion</h2>

      <p className="overview">
        {name}, your numerology chart reflects a coherent structure of personal
        tendencies, life direction, and timing influences. The interaction of
        these numbers provides insight into how your inner nature aligns with
        your external experiences.
      </p>

      <p className="overview">
        Your <strong>Life Path Number {lifePath.number}</strong> represents the
        fundamental traits through which you approach life, while your{" "}
        <strong>Destiny Number {destiny.number}</strong> defines the broader
        purpose toward which your abilities are directed.
      </p>

      <p className="overview">
        The influence of your <strong>Personal Year {personalYear.number}</strong>{" "}
        highlights the themes most active in your current cycle, shaping the
        pace, opportunities, and lessons of this period.
      </p>

      <p className="overview">
        When viewed collectively, these numbers do not indicate fixed outcomes,
        but rather patterns of potential. Conscious awareness of these patterns
        allows you to make balanced decisions, develop your strengths, and
        approach challenges with clarity and discipline.
      </p>
    </div>
  );
};


/* ================= LO SHU GRID ================= */
const LoShuGrid = ({ data }) => (
  <div className="section">
    <div className="section-header">
      <div className="number-badge">⧉</div>
      <h2>Lo Shu Grid</h2>
    </div>

    <div className="loshu-grid">
      {[4, 9, 2, 3, 5, 7, 8, 1, 6].map((num) => (
        <div key={num} className="loshu-cell">
          <span className="loshu-number">{num}</span>
          <span className="loshu-count">{data.grid[num] || 0}</span>
        </div>
      ))}
    </div>

    <p><strong>Missing Numbers:</strong> {data.missingNumbers.join(", ")}</p>
    <p><strong>Repeated Numbers:</strong> {data.repeatedNumbers.join(", ")}</p>
    
  </div>
);

export default NumerologyMasterReport;
